import { FC } from 'react';
import { Button, Tooltip } from 'antd';
import cs from 'classnames';
import { AreaProtectionResult } from './collision';
import styles from './index.module.less';

export type AreaProtectionApprovalStatus = 'pending' | 'approving' | 'approved' | 'rejected';

const AreaProtectionPanel: FC<{
  result?: AreaProtectionResult;
  isLoading?: boolean;
  approvalStatus?: AreaProtectionApprovalStatus;
  approvalOpinion?: string;
  disabled?: boolean;
  onOpenApply?: () => void;
}> = ({
  result,
  isLoading = false,
  approvalStatus = 'pending',
  approvalOpinion = '',
  disabled,
  onOpenApply,
}) => {
  const displayLevel = approvalStatus === 'approving' || approvalStatus === 'approved' ? 'approval' : approvalStatus === 'rejected' ? 'danger' : result?.level || 'pending';
  const statusText = approvalStatus === 'approving' ? '特殊申请审批中，暂不可关联拓店任务' : approvalStatus === 'approved' ? '申请已通过，本机会点已豁免区域保护，可关联拓店任务' : approvalStatus === 'rejected' ? '特殊申请被驳回，维持区域保护拦截，不可关联拓店任务' : isLoading ? '正在查询周边本品牌门店，请稍候。' : result?.summary || '请选择详细地址后检测周边本品牌门店。';
  const statusLabel = approvalStatus === 'approving' ? '审批中' : approvalStatus === 'approved' ? '审批通过' : approvalStatus === 'rejected' ? '审批驳回' : isLoading ? '检测中' : result?.level === 'danger' ? '预警' : result?.level === 'warning' ? '提醒' : result?.level === 'normal' ? '正常' : '待检测';
  const showActions = !!onOpenApply;

  return <div className={styles.areaProtection}>
    <div className={styles.header}>
      <div className={styles.heading}>
        <p>检测对象：本品牌正式门店（永久保护）+ 保护期内在途机会点，距离算法：直线初筛 + 步行路径精算</p>
      </div>
      <div className={styles.legend}>
        <span className={styles.danger}><i />预警≤200m</span>
        <span className={styles.warning}><i />提示200m-500m</span>
        <span className={styles.normal}><i />正常≥500m</span>
      </div>
    </div>
    <div className={cs(styles.statePanel, styles[displayLevel])}>
      <div className={styles.statusBar}>
        <span className={styles.statusText}><i />{statusLabel}<b>{statusText}</b>{approvalStatus === 'approving' && <em>审批中</em>}{approvalStatus === 'approved' && <em>审批通过</em>}{approvalStatus === 'rejected' && <em>审批驳回</em>}{approvalStatus === 'rejected' && approvalOpinion ? ` 审批意见：${approvalOpinion}` : ''}</span>
        {showActions && <div className={styles.actions}>
          {result?.allowApply && approvalStatus === 'pending' && onOpenApply && <Button type='primary' danger disabled={disabled} onClick={onOpenApply}>发起特殊申请</Button>}
          {approvalStatus === 'rejected' && onOpenApply && <Button type='primary' danger disabled={disabled} onClick={onOpenApply}>发起特殊申请</Button>}
        </div>}
      </div>
      {!!result?.items.length && <div className={styles.storeList}>
        {result.items.map((item) => <div key={item.id} className={styles.storeItem}>
          <div className={styles.storeName}>
            <Tooltip title={item.name}>
              <span className={styles.storeNameText}>{item.name}</span>
            </Tooltip>
            <span className={item.type === '门店' ? styles.storeTagDanger : styles.storeTagWarning}>{item.type === '门店' ? '正式门店-永久保护' : '机会点-区域保护'}</span>
          </div>
          <div className={styles.storeMeta}>{`步行：${item.walkingDistance}`}<span>{`保护到期：${item.protectionEndDate}`}</span></div>
        </div>)}
      </div>}
    </div>
  </div>;
};

export default AreaProtectionPanel;
